// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0c626c0a","491":"5e3e3027","670":"cb0dcdc8","704":"ed2d5a30","787":"bb20b309","886":"20de81a3","983":"8b5257e1"}[chunkId] + ".chunk.js";
};